import { Scroll } from '../helpers/scroll';
import { breakpoints } from '../helpers/constants';

export class Sticky {

	constructor(elem) {
		this.elem = elem;

		this.headerImg = document.querySelector('.event-content__header-img');
		this.header = document.querySelector('.event-content__header');
		this.richText = document.querySelector('.event-content__rich-text');
		this.meta = document.querySelector('.event-content__meta');
		this.innerMeta = document.querySelector('.event-content__meta__inner');
		this.ctaWrapper = document.querySelector('.event-content__cta-wrapper');
		this.mainmenu = document.querySelector('header.main-navigation');
		this.menuHeight = this.getMainMenuHeight();

		this.lastScrollTop = 0;

		this.setTopOfViewport();
		if (this.stickyNeeded()) {
			// Needs a timeout because Chrome detects triple size sticky element
			setTimeout(() => {
				this.addEventHandlers();
				this.handleScroll();
			}, 50);
		}

	}

	static getSelector() {
		return '[data-sticky]';
	}

	setMobileDifference() {
		// Breakpoint is based on $breakpoint--medium CSS variable
		if (window.innerWidth < 641) {
			const paddingTop = parseInt(window.getComputedStyle(this.meta, null).getPropertyValue('padding-top'));
			const metaInnerHeight = this.innerMeta.clientHeight;
			const ctaWrapperHeight = this.ctaWrapper.clientHeight;
			this.mobileDifference = paddingTop + metaInnerHeight - ctaWrapperHeight;
		} else {
			this.mobileDifference = 0;
			this.header.style.transform = 'translateY(0px)';
		}
	}

	stickyNeeded() {
		if (window !== window.top) {
			// we're in an iframe, most likely inside hippo, then ditch the sticky functionality
			return false;
		}
		return true;
	}

	addEventHandlers() {
		window.addEventListener('scroll', () => {
			this.handleScroll();
		});
		window.addEventListener('resize', () => {
			this.menuHeight = this.getMainMenuHeight();
			this.setElementDimensions(this.headerImg);
		});
	}

	setElementDimensions(target) {
		this.setMobileDifference();

		const offsetTop = target.getBoundingClientRect().top + this.topOfViewport;
		const elementHeight = target.clientHeight;
		this.bottomOfElement = offsetTop + elementHeight;
		this.bottomOfElement += this.mobileDifference;
	}

	setTopOfViewport() {
		this.topOfViewport = (document.documentElement.scrollTop || document.body.scrollTop);
	}

	handleScroll() {
		this.setTopOfViewport();
		this.setElementDimensions(this.headerImg);
		this.handleTopPosition();

		const scrollCheck = Scroll.checkScrollDirection(this.lastScrollTop);
		const direction = scrollCheck.direction;
		this.lastScrollTop = scrollCheck.scrollTop;

		if (direction === 'down' && ( this.topOfViewport > this.bottomOfElement )) {
			this.header.classList.add('fixed-to-top');
			this.richText.style.paddingTop = this.header.clientHeight + 'px';
			if (this.mobileDifference > 0) {
				this.header.style.transform = `translateY(-${this.mobileDifference}px)`;
			}
		}
		if(direction === 'up' && (this.topOfViewport + this.menuHeight < this.bottomOfElement)) {
			this.header.classList.remove('fixed-to-top');
			this.richText.style.paddingTop = '0px';
			this.header.style.top = '0px';
			this.header.style.transform = 'translateY(0px)';
		}

	}

	/**
	 * Gets the main menu height
	 * @returns {number}
	 */
	getMainMenuHeight(){
		return breakpoints.isIpad() ? this.mainmenu.offsetHeight : this.mainmenu.scrollHeight;
	}

	/**
	 * Handles the top position of the header, because we've got a sticky header now
	 */
	handleTopPosition(){
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		if(document.body.classList.contains('_has-visible-header') && scrollTop > this.menuHeight){
			this.header.style.top = this.menuHeight + 'px';
		}else{
			this.header.style.top = '0px';
		}
	}

}

